import React, { useContext, useEffect, useState } from "react";
import { ACCOUNT_TYPE_NORMAL } from "@config/config";
import { AuthContext } from "@context/AuthContext";
import Loader from "@components/Ui/Loader";
import MovieTile from "@components/V3/Movies/MovieTile";
import { fetchWatchlistStatus } from "@utils/watchlistService";

const MoviesNowShowing = () => {
    const { nowShowing, isMoviesLoading, user } = useContext(AuthContext);
    const [watchlistStatus, setWatchlistStatus] = useState(null);
    const [watchlistError, setWatchlistError] = useState(false);
    const isNormal = user?.account_type_id === ACCOUNT_TYPE_NORMAL;

    useEffect(() => {
        let isStale = false;

        if (isNormal && nowShowing.length > 0) {
            setWatchlistError(false);
            const movieIds = nowShowing.map(movie => movie.movie_id);
            fetchWatchlistStatus(movieIds, user, (status) => {
                if (!isStale) {
                    setWatchlistStatus(status ?? {});
                    setWatchlistError(status === null);
                }
            });
        } else if (!isNormal) {
            setWatchlistStatus({});
        }

        return () => {
            isStale = true;
        };
    }, [nowShowing, user, isNormal]);

    if (isMoviesLoading) {
        return <Loader isLoading={isMoviesLoading} />;
    }

    if (nowShowing.length === 0) {
        return (
            <div className="movie-list__content">
                <p className="movie-list__no-movies">
                    There was an error obtaining the Now Showing movies. Please try again.
                </p>
            </div>
        );
    }

    if (isNormal && watchlistStatus === null) {
        return <Loader isLoading={true} />;
    }

    return (
        <div className="movie-list__content">
            {watchlistError && (
                <div className="movie-list__warning">
                    <p>Unable to load watchlist status. Watchlist features may not work correctly.</p>
                </div>
            )}
            {nowShowing.map((movie) => (
                <div className="movie-list__item" key={movie.movie_id}>
                    <MovieTile
                        movie={movie}
                        variant="now-showing"
                        initialInWatchlist={(watchlistStatus || {})[movie.movie_id] || false}
                    />
                </div>
            ))}
        </div>
    );
};

export default MoviesNowShowing;
